const addOrientationChangeListenerInEffect = (func) => {
   window.addEventListener('debouncedresize', func);
   return () => window.removeEventListener('debouncedresize', func);
};

export { addOrientationChangeListenerInEffect };
